import { Form, InputGroup } from 'react-bootstrap'
import InputNumber from 'rc-input-number'
import { useTranslation } from 'react-i18next'

import { numbersOnly } from '../../../_services/common.service'

import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'

import 'rc-input-number/assets/index.css'
import './InputNumber.scss'

const InputNumberComponent = ({
  dmode,
  min = 0,
  max = Number.MAX_SAFE_INTEGER,
  label,
  value,
  onValueChange,
  placeholder,
  name = '',
  style,
  dir = 'ltr',
  handleKeyPress,
  inputClassName,
  allowDecimal = false,  // New prop to enable decimal input
  step,
  disabled = false,
}) => {
  const { t } = useTranslation()

  const onlyNumbers = (value) => {
    // If decimals allowed, keep digits and decimal point
    if (allowDecimal) {
      return value.replace(/[^\d.]/g, '') // Keep digits and decimal point
    }
    return value.replace(/[^\d]/g, '') // Remove anything that is not a digit
  }

  return (
    <>
      <Form.Group dir={dir} style={{ width: '100%' }}>
        {label ? (
          <Form.Label className="glo-label">{t(label)}</Form.Label>
        ) : (
          <Form.Label className="glo-label" style={{ color: 'transparent' }}>
            *
          </Form.Label>
        )}
        <InputGroup style={{ width: '100%' }} dir={dir}>
          <InputNumber
            onKeyDown={(evt) => {
              // Allow decimal point if allowDecimal is true
              if (evt.key === '.' && !allowDecimal) {
                evt.preventDefault()
              } else if (evt.key === 'Enter') {
                handleKeyPress && handleKeyPress(evt)
              } else {
                numbersOnly(evt, value, t('Character.results'))
              }
            }}
            disabled={disabled}
            dir={dir}
            min={min}
            max={max}
            step={step !== undefined ? step : allowDecimal ? 0.01 : 1}
            parser={onlyNumbers}
            type="number"
            value={value}
            onChange={(val) => {
              onValueChange(val, name)
            }}
            style={{
              direction: dir === 'rtl' ? 'rtl' : 'ltr',
              textAlign: dir === 'rtl' ? 'right' : 'left',
              display: dir === 'rtl' ? 'flex' : '',
              flexDirection: dir === 'rtl' ? 'row-reverse' : '',
              ...style,
              width: '100%',
            }}
            className={`custom-input-number ${dir === 'rtl' ? 'rtl' : ''} ${
              dmode && 'custom-input-number-dark'
            }`}
            upHandler={
              <div
                className={`custom-up-handler ${
                  dmode && 'custom-up-handler-dark'
                }`}
              >
                <ChevronUpIcon
                  style={{
                    width: 10,
                    height: 20,
                    color: dmode ? 'white' : '#4F4F4F',
                  }}
                />
              </div>
            }
            downHandler={
              <div
                className={`custom-down-handler ${
                  dmode && 'custom-down-handler-dark'
                }`}
              >
                <ChevronDownIcon
                  style={{
                    width: 10,
                    height: 14,
                    color: dmode ? 'white' : '#4F4F4F',
                  }}
                />
              </div>
            }
            placeholder={t(placeholder)}
            autoFocus={false}
          />
        </InputGroup>
      </Form.Group>
    </>
  )
}

export default InputNumberComponent
